import React, {useState} from 'react';
import style from '../style/events.module.css';
import styleExplore from "../style/explore.module.css";
import { Link } from 'react-router-dom';
import {CalendarOutlined} from "@ant-design/icons";
import {IoIosArrowBack, IoMdNotificationsOutline} from "react-icons/io";
import data from "../data/events.json";
import BottomSheet from '../components/BottomSheet';

function Events(){
    const [itemsVisible, setItemsVisible] = useState(true);
    const [sheetCreateRoom, setSheetCreateRoom] = useState(false);
    const [sheetVisible, setSheetVisible] = useState(false);
    const [loaderVisibility, setLoaderVisibility] = useState(false);
    return(
        <div className={style.eventContainer}>
            <div className={`${styleExplore.head} px-2 pt-2 pb-3`}>
                <Link to="/home" className={styleExplore.btnBack}>
                    <IoIosArrowBack/>
                </Link>
                <h3 className='mx-auto'>UPCOMING FOR YOU</h3>
                <Link to='/calendar' className={`${style.calendar} d-flex align-self-center`}>
                     <CalendarOutlined />
                </Link>
            </div>
            <h2 className={`${style.eventDay} p-1`}>TODAY</h2>
            <div className={`${style.event} px-2`}>
               {data.map((item)=>{
                    const {id,time,title,members,description} = item;
                    return(
                        <div key={id} className={`${style.item} mt-3`} onClick={()=>setSheetVisible(true)}>
                            <IoMdNotificationsOutline/>
                            <h4 className='mb-1'>{time}</h4>
                            <h2>{title}</h2>
                            <img src={members.firstImage} alt='member'/>
                            <img src={members.secondImage} alt='member' className='mx-1'/>
                            <img src={members.thirdImage} alt='member' className='mx-1'/>
                            <img src={members.fourthImage} alt='member'/>
                            <p className='mt-2'>{description}</p>
                        </div>
                    )
               })}
            </div>
            <BottomSheet
                sheetTitle="start event"
                setSheetVisible={(item)=>setSheetVisible(item)}
                sheetVisible={sheetVisible}
                setItemsVisible={(item)=>setItemsVisible(item)}
                setSheetCreateRoom={(item) => {
                    setLoaderVisibility(true);
                    setTimeout(()=>{
                        setSheetCreateRoom(item);
                        setLoaderVisibility(false);
                    }, 1000)
                }}/>
        </div>
    )
}

export default Events;